// /frontend/src/styles/RavenStyleGlobalReset.jsx

import React from "react";
import { Global } from "@emotion/react";

export function RavenStyleGlobalReset() {
	return (
		<Global
			styles={{
				html: {
					boxSizing: "border-box",
					WebkitFontSmoothing: "antialiased",
					MozOsxFontSmoothing: "grayscale",
					height: "100%",
				},
				"*, *::before, *::after": { boxSizing: "inherit" },
				body: {
					margin: 0,
					minHeight: "100%",
					background: "white",
					color: "inherit",
					lineHeight: 1.5,
				},
				"#root": { minHeight: "100%" },
				"strong, b": { fontWeight: "bolder" },
				"img, picture, video, canvas, svg": {
					display: "block",
					maxWidth: "100%",
				},
				"h1,h2,h3,h4,h5,h6,p": { margin: 0 },
			}}
		/>
	);
}
